import { useQuery } from '@tanstack/react-query';
import { getUserById } from './users';

const fetchUserDetails = async (userId: number) => {
  const res = await getUserById(userId);

  return res;
};

export const useUserDetails = (user: string | null) =>
  useQuery({
    queryKey: ['userDetails', user],
    queryFn: async () => {
      if (!user) return null;

      const userDet = JSON.parse(user);

      return fetchUserDetails(userDet.id);
    },
    enabled: !!user, // only run query if `user` exists
  });
